<template>
    <v-dialog v-model="dialog">
        
        <v-card>
            <v-app-bar class="mb-5" flat color="transparent">
                <v-btn large icon  @click="$emit('back')">
                    <v-icon color="primary">mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title class="title">
                    Pré visualização da Nota Fiscal
                </v-toolbar-title>
        
            </v-app-bar>

            <v-list >
                <v-list-group :value="false" no-action sub-group>

                    <template v-slot:activator>

                        <v-list-item-content>
                        <v-list-item-title>PDF</v-list-item-title>
                        </v-list-item-content>

                    </template>

                    <v-list-item class='pl-2'>

                        <iframe style="width:100%; height: 90vh" :src="`data:application/pdf;base64,${notasFiscalPreVisualizacao}`" type="application/pdf"></iframe>

                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-card>

    </v-dialog>
</template>

<script>
export default {
    name: 'PreviewNotaFiscalView',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        notasFiscalPreVisualizacao: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        closeDialog() {
            this.$emit('update:dialog', false);
        }
    },

    watch: {
        open(newValue){
            console.log('open', newValue);
            this.dialog = newValue;
        }
    }
}
</script>